import "@fontsource-variable/ibm-plex-sans";
import "@fontsource-variable/noto-sans-sc";
import "@fontsource/jetbrains-mono";
import "antd/dist/reset.css";
import "./styles/tokens.css";
import "./styles/global.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
